import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, formatApiError } from "../lib/api";
import { tr, lbl } from "../lib/i18n";

export function AddLeadDialog({ facets, onClose, onDone }) {
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", mobile: "+968", email: "", source: "Walk-in", referrer_name: "", referrer_phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/leads", { ...f, email: f.email || null });
      toast.success(data.merged ? (data.owner ? tr("ld.merged_owner", { p0: data.owner }) : tr("ld.merged")) : tr("ld.created"));
      onDone();
      if (data.visible !== false) nav(`/leads/${data.lead.id}`);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="add-lead-dialog">
        <DialogHeader className="pe-8"><DialogTitle>{tr("ld.add")}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <label className="block text-sm">{tr("enq.name")}<input className="input w-full mt-1" value={f.name} onChange={set("name")} required data-testid="lead-name" /></label>
          <label className="block text-sm">{tr("ld.mobile")}<input className="input w-full mt-1" dir="ltr" value={f.mobile} onChange={set("mobile")} required data-testid="lead-mobile" /></label>
          <label className="block text-sm">{tr("enq.email")}<input className="input w-full mt-1" dir="ltr" type="email" value={f.email} onChange={set("email")} data-testid="lead-email" /></label>
          <label className="block text-sm">{tr("ld.col_source")}
            <select className="input w-full mt-1 h-10" value={f.source} onChange={set("source")} data-testid="lead-source">
              {(facets?.manual_sources || ["Walk-in"]).map((s) => <option key={s} value={s}>{lbl(s)}</option>)}
            </select>
          </label>
          {f.source === "Referral" && (
            <div className="grid grid-cols-2 gap-2">
              <label className="block text-sm">{tr("ld.referrer")}<input className="input w-full mt-1" value={f.referrer_name} onChange={set("referrer_name")} data-testid="lead-referrer" /></label>
              <label className="block text-sm">{tr("ld.referrer_phone")}<input className="input w-full mt-1" dir="ltr" value={f.referrer_phone} onChange={set("referrer_phone")} data-testid="lead-referrer-phone" /></label>
            </div>
          )}
          <label className="block text-sm">{tr("enq.message")}<textarea className="input w-full mt-1" value={f.message} onChange={set("message")} data-testid="lead-message" /></label>
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" className="btn-secondary" onClick={onClose} data-testid="lead-cancel">{tr("enq.close")}</button>
            <button className="btn-primary" disabled={busy} data-testid="lead-save">{tr("ld.save")}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
